module.exports = __webpack_public_path__ + "img/GW.50cec7fd.svg";